import React from 'react';
import { Route, Switch } from 'react-router-dom';
import PageHeader from '../../components/PageHeader';
import RedirectToHome from '../../components/RedirectToHome';
import { ApprovalRequestNav } from './ApprovalRequestNav';
import { routes } from './routes';
import { useNamespacedTranslation } from '../../../../hooks/useNamespacedTranslation';
import { useFlairBreadcrumbHook } from '../../../../hooks/useFlairBreadcrumbHook';

const Content: React.FC = () => (
  <Switch>
    {Object.values(routes()).map(({ render, route }, i) => (
      <Route
        key={i}
        exact={true}
        path={route.template()}
        render={() => render()}
      />
    ))}
    <Route path="*">
      <RedirectToHome />
    </Route>
  </Switch>
);

const i18Path = 'approvalRequest';
export const ApprovalRequestsTabs: React.FC = () => {
  const t = useNamespacedTranslation(i18Path);

  useFlairBreadcrumbHook([{ label: t('title') }]);

  return (
    <>
      <PageHeader title={t('title')} actions={[]}>
        <ApprovalRequestNav />
      </PageHeader>
      <Content />
    </>
  );
};
